export default __webpack_public_path__ + "static/media/43t.f556d80c.jpg";